// app/frontend/components/layouts/PageContainer.tsx
import { Box } from "@mantine/core";
import type { ReactNode } from "react";

export type PageContainerSize = "xs" | "sm" | "md" | "lg";

const SIZE_MAP: Record<PageContainerSize, string> = {
  xs: "420px",
  sm: "800px",
  md: "1200px",
  lg: "1600px",
};

interface PageContainerProps {
  children: ReactNode;
  size?: PageContainerSize;
  className?: string;
}

export default function PageContainer({
  children,
  size = "md",
  className,
}: PageContainerProps) {
  return (
    <Box
      className={className}
      px={{ base: "sm", sm: "md", md: "lg" }}
      style={{
        maxWidth: SIZE_MAP[size],
        margin: "0 auto",
        width: "100%",
      }}
    >
      {children}
    </Box>
  );
}
